import axios from 'axios';

const getHeaders = () => {
    return {};
};

export default axios.create({
    baseURL: process.env.REACT_APP_API_PAYMENT_UAT_URI,
    headers: getHeaders(),
});
